import React, { Component } from "react";

// MetisMenu
import MetisMenu from "metismenujs";
// import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from 'react-i18next';

import { connect } from "react-redux";
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader
} from "../../store/actions";
import withRouter from "../Common/withRouter";

class SidebarContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pathName: this.props.router.location.pathname,
    };

  }

  componentDidMount() {
    setTimeout(() => {
      this.initMenu();
    }, 100);
  }

  componentDidUpdate(prevProps) {
    const currentPath = this.props.router.location.pathname;
    const prevPath = prevProps.router.location.pathname;

    if (currentPath !== prevPath) {
      this.setState({ pathName: currentPath }, () => {
        setTimeout(() => {
          this.initMenu();
        }, 50);
      });
    }

    if (this.props.type !== prevProps.type) {
      setTimeout(() => {
        this.initMenu();
      }, 100);
    }
  }

  initMenu() {
    const existingMenu = document.getElementById("side-menu");
    if (existingMenu._metisMenu) {
      existingMenu._metisMenu.dispose();
    }
    new MetisMenu("#side-menu");

    this.activateCurrentMenuItem();
  }

  activateCurrentMenuItem = () => {
    const { pathName } = this.state;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");

    // Remove active classes from all items first
    for (let i = 0; i < items.length; i++) {
      items[i].classList.remove("active");
      this.removeActiveClasses(items[i]);
    }

    // Find and activate current menu item
    for (let i = 0; i < items.length; i++) {
      if (pathName === items[i].pathname) {
        this.activateParentDropdown(items[i]);
        break;
      }
    }
  }

  removeActiveClasses = (item) => {
    let parent = item.parentElement;
    while (parent) {
      parent.classList.remove("mm-active", "mm-show");
      parent = parent.parentElement;
      if (parent && parent.classList.contains("metismenu")) {
        break;
      }
    }
  }

  activateParentDropdown = (item) => {
    item.classList.add("active");
    let parent = item.parentElement;

    while (parent) {
      if (parent.classList.contains("metismenu")) {
        break;
      }

      if (parent.classList.contains("mm-show") || parent.classList.contains("mm-active")) {
        parent = parent.parentElement;
        continue;
      }

      parent.classList.add("mm-active");

      const parentLink = parent.querySelector('a');
      if (parentLink && !parentLink.classList.contains('has-arrow')) {
        parentLink.classList.add("mm-active");
      }

      const parentUl = parent.querySelector('ul');
      if (parentUl) {
        parentUl.classList.add("mm-show");
      }

      parent = parent.parentElement;
    }
    return false;
  };

  render() {
    const { pathName } = this.state;
    return (
      <React.Fragment>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{this.props.t('Menu')}</li>

            {/* <li>
              <Link to="/dashboard" className={`waves-effect${pathName === '/dashboard' ? ' active' : ''}`}>
                <i className="ri-dashboard-line"></i><span className="badge rounded-pill bg-success float-end"></span>
                <span className="ms-1">{this.props.t('Dashboard')}</span>
              </Link>
            </li> */}

            <li>
              <Link to="/categories" className={`waves-effect${pathName === '/categories' ? ' active' : ''}`}>
                <i className="ri-store-2-line"></i>
                <span className="ms-1">{this.props.t('Categories')}</span>
              </Link>
            </li>

            <li>
              <Link to="/trending-categories" className={`waves-effect${pathName === '/trending-categories' ? ' active' : ''}`}>
                <i className="ri-fire-line"></i>
                <span className="ms-1">{this.props.t('Trending Category')}</span>
              </Link>
            </li>
            <li>
              <Link to="/cta-section" className={`waves-effect${pathName === '/cta-section' ? ' active' : ''}`}>
                <i className="ri-layout-3-line"></i>
                <span className="ms-1">{this.props.t('CTA Section')}</span>
              </Link>
            </li>

            <li>
              <Link to="/destinations" className={`waves-effect${pathName === '/destinations' ? ' active' : ''}`}>
                <i className="ri-store-2-line"></i>
                <span className="ms-1">{this.props.t('Destinations')}</span>
              </Link>
            </li>

            <li>
              <Link to="/bookings" className={`waves-effect${pathName === '/bookings' ? ' active' : ''}`}>
                <i className="ri-store-2-line"></i>
                <span className="ms-1">{this.props.t('Bookings')}</span>
              </Link>
            </li>

            <li>
              <Link to="/tours" className={`waves-effect${pathName === '/tours' ? ' active' : ''}`}>
                <i className="ri-store-2-line"></i>
                <span className="ms-1">{this.props.t('Tours')}</span>
              </Link>
            </li>

            <li>
              <Link to="/educational-tours" className={`waves-effect${pathName === '/educational-tours' ? ' active' : ''}`}>
                <i className="ri-book-read-line"></i>
                <span className="ms-1">{this.props.t('Educational Tours')}</span>
              </Link>
            </li>

            <li>
              <Link to="/tourinclusions" className={`waves-effect${pathName === '/tourinclusions' ? ' active' : ''}`}>
                <i className="ri-store-2-line"></i>
                <span className="ms-1">{this.props.t('Tour Inclusions')}</span>
              </Link>
            </li>

            <li>
              <Link to="/tourexclusions" className={`waves-effect${pathName === '/tourexclusions' ? ' active' : ''}`}>
                <i className="ri-close-circle-line"></i>
                <span className="ms-1">{this.props.t('Tour Exclusions')}</span>
              </Link>
            </li>

            <li>
              <Link to="/testimonials" className={`waves-effect${pathName === '/testimonials' ? ' active' : ''}`}>
                <i className="ri-chat-quote-line"></i>
                <span className="ms-1">{this.props.t('Testimonials')}</span>
              </Link>
            </li>

            <li>
              <Link to="/gallery" className={`waves-effect${pathName === '/gallery' ? ' active' : ''}`}>
                <i className="ri-image-line"></i>
                <span className="ms-1">{this.props.t('Gallery')}</span>
              </Link>
            </li>

          </ul>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = state => {
  return { ...state.Layout };
};

export default withRouter(connect(mapStatetoProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeLayoutWidth,
  changePreloader
})(withTranslation()(SidebarContent)));
